import { fieldTypeNameFromId } from './fieldTypeLegacy'
import type { ObjectPassportFieldDefinition } from './types'

/**
 * Строит payload для привязки дочерних объектов: полная желаемая выборка ID.
 * Инверс `buildUnlinkPayload` — отправляет весь набор отмеченных ID.
 */
export function buildLinkPayload(
  field: ObjectPassportFieldDefinition,
  desiredIds: number[],
): { field_id: number; value: string | null; value_list?: number[] | null } {
  const typeName = fieldTypeNameFromId(field.field_type)
  const fieldId = field.id
  const ids = desiredIds.filter((id) => Number.isFinite(id) && id > 0)

  if (typeName === 'one_to_many' || typeName === 'many_to_many') {
    return {
      field_id: fieldId,
      value: null,
      value_list: ids.length > 0 ? ids : null,
    }
  }

  const singleId = ids[0] ?? null
  return {
    field_id: fieldId,
    value: singleId != null ? String(singleId) : null,
    value_list: null,
  }
}
